export default "__VITE_ASSET__C4yb3cLK__"